const secretariasData = [
  {
    sigla: 'SAPIC',
    nome: 'Assuntos Portuários, Indústria e Comércio'
  },
  {
    sigla: 'SAPDC',
    nome: 'Assuntos Portuários e Desenvolvimento da Região Central'
  },
  {
    sigla: 'SAPDRC',
    nome: 'Assuntos Portuários e Desenvolvimento da Região Central'
  },
  {
    sigla: 'SEAS',
    nome: 'Assistência Social'
  },
  {
    sigla: 'SECID',
    nome: 'Defesa da Cidadania'
  },
  {
    sigla: 'SECOM',
    nome: 'Comunicação'
  },
  {
    sigla: 'SECOR',
    nome: 'Comunicação e Resultados'
  },
  {
    sigla: 'SECULT',
    nome: 'Cultura'
  },
  {
    sigla: 'SEDES',
    nome: 'Desenvolvimento Econômico e Inovação'
  },
  {
    sigla: 'SEDUC',
    nome: 'Educação'
  },
  {
    sigla: 'SEDS',
    nome: 'Desenvolvimento Social'
  },
  {
    sigla: 'SEDURB',
    nome: 'Desenvolvimento Urbano'
  },
  {
    sigla: 'SEECTUR',
    nome: 'Empreendedorismo, Economia Criativa e Turismo'
  },
  {
    sigla: 'SEFIN',
    nome: 'Finanças'
  },
  {
    sigla: 'SEGES',
    nome: 'Gestão'
  },
  {
    sigla: 'SERIC',
    nome: 'Relações Institucionais e Cidadania'
  },
  {
    sigla: 'SESERP',
    nome: 'Serviços Públicos'
  },
  {
    sigla: 'SETUR',
    nome: 'Turismo'
  },
  {
    sigla: 'GPM',
    nome: 'Gabinete do Prefeito'
  },
  {
    sigla: 'GVP',
    nome: 'Gabinete do Vice-Prefeito'
  },
  {
    sigla: 'SEGOV',
    nome: 'Governo'
  },
  {
    sigla: 'SEMAM',
    nome: 'Meio Ambiente'
  },
  {
    sigla: 'SMS',
    nome: 'Saúde'
  },
  {
    sigla: 'SIEDI',
    nome: 'Infraestrutura e Edificações'
  },
  {
    sigla: 'OC',
    nome: 'Ouvidoria e Controle'
  },
  {
    sigla: 'OTC',
    nome: 'Ouvidoria Transparência e Controle'
  },
  {
    sigla: 'OPM',
    nome: 'Ouvidoria Pública'
  },
  {
    sigla: 'SEPORT',
    nome: 'Assuntos Portuários'
  },
  {
    sigla: 'SEMES',
    nome: 'Esportes'
  },
  {
    sigla: 'PGM',
    nome: 'Procuradoria'
  },
  {
    sigla: 'SECC',
    nome: 'Comunicação e Economia Criativa'
  },
  {
    sigla: 'SESEG',
    nome: 'Segurança'
  },
  {
    sigla: 'SEPLAN',
    nome: 'Planejamento e Inovação'
  },
  {
    sigla: 'SEPORT-RC',
    nome: 'Assuntos Portuários e Desenvolvimento da Região Central'
  },
  {
    sigla: 'SEOBE',
    nome: 'Obras e Edificações'
  },
  {
    sigla: 'SEINFRA',
    nome: 'Infraestrutura e Serviços Públicos'
  },
  {
    sigla: 'SEMULHER',
    nome: 'Mulher, Cidadania, Diversidade e Direitos Humanos'
  },
  {
    sigla: 'SEPORTE',
    nome: 'Assuntos Portuários e Emprego'
  },
  {
    sigla: 'GAB-GPM',
    nome: 'Gabinete do Prefeito'
  },
  {
    sigla: 'SEPREF',
    nome: 'Prefeituras Regionais'
  },
  {
    sigla: 'SAES',
    nome: 'Assuntos Estratégicos, Legislativos e Metropolitanos'
  }
]

const autarquiasData = [
  {
    sigla: 'FAMS-AP',
    nome: 'Fundação Arquivo e Memória'
  },
  {
    sigla: 'FPTS',
    nome: 'Fundação Parque Tecnológico'
  },
  {
    sigla: 'FUPES',
    nome: 'Fundação Pró-Esporte'
  },
  {
    sigla: 'CAPEP-SAUDE',
    nome: 'Caixa Beneficente dos Funcionários Municipais'
  },
  {
    sigla: 'CET',
    nome: 'Companhia de Engenharia de Tráfego de Santos'
  },
  {
    sigla: 'COHAB',
    nome: 'Companhia de Habitação da Baixada Santista'
  },
  {
    sigla: 'IPREV',
    nome:
      'Instituto de Previdência Social dos Servidores Públicos Municipais de Santos'
  },
  {
    sigla: 'PRODESAN',
    nome: 'Progresso e Desenvolvimento de Santos S/A'
  }
]

function sortData(data) {
  data.sort((a, b) => a.sigla > b.sigla)
  return data
}

export const secretarias = () => [...sortData(secretariasData)]

export const autarquias = () => [...sortData(autarquiasData)]

export const entidades = [
  ...sortData(secretariasData),
  ...sortData(autarquiasData)
]

export const entidadeBySigla = sigla => {
  const found = entidades.find(i => i.sigla === sigla)

  if (!found) return sigla

  return found ? found.nome : null
}



// WEBPACK FOOTER //
// ./src/utils/entidades.js